export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/8e8641da5546a83267ff7cb844712535.svg";